<template>
  <div>
    <b-overlay :show="isLoading" rounded="md">
      <!-- Linha 1: Resumo Geral -->
      <h5 class="mb-2">Resumo geral</h5>
      <b-row class="mb-2">
        <b-col md="3" sm="6" v-for="(stat, index) in resumoGeral" :key="'resumo-'+index">
          <b-card class="shadow-sm border-0 h-100">
            <div class="d-flex align-items-center">
              <div class="mr-3">
                <feather-icon :icon="stat.icon" :class="`text-${stat.color}`" size="24"/>
              </div>
              <div>
                <p class="card-text small text-muted mb-0">{{ stat.title }}</p>
                <h5 class="font-weight-bolder mb-0">{{ stat.value }}</h5>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- Linha 2: Desempenho de Vendas e Estatísticas Admin -->
      <b-row class="mb-2">
        <b-col lg="8">
          <b-card no-body class="shadow-sm border-0 h-100">
            <b-card-header class="pb-0">
              <b-card-title>Desempenho de Vendas</b-card-title>
            </b-card-header>
            <b-card-body>
              <!-- Usando componente personalizado -->
              <bar-chart :chart-data="chartDataDesempenho" :options="chartOptions" :height="300" />
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="4">
          <b-card no-body class="shadow-sm border-0 h-100">
             <b-card-header>
              <b-card-title>Estatísticas Administrador</b-card-title>
            </b-card-header>
            <b-card-body>
              <div v-for="(item, index) in estatisticasAdmin" :key="'admin-stat-'+index" class="d-flex align-items-center mb-3">
                <div class="mr-3">
                  <div :class="`rounded-circle p-2 bg-light-${item.color}`">
                    <feather-icon :icon="item.icon" :class="`text-${item.color}`" size="18"/>
                  </div>
                </div>
                <div>
                  <h6 class="font-weight-bolder mb-0">{{ item.value }}</h6>
                  <p class="card-text small text-muted mb-0">{{ item.title }}</p>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <!-- Linha 3: Título Contagem de Usuários -->
      <h5 class="mb-2 mt-3">
        Contagem de Usuários
      </h5>

      <!-- Linha 4: Contagem de Vendedores, Afiliados, Clientes e Padrinhos -->
      <b-row>
        <b-col
          lg="3"
          v-for="(contador, index) in contagemUsuarios"
          :key="'contador-'+index"
          class="mb-2"
        >
          <b-card class="shadow-sm border-0 py-2">
            <div class="d-flex align-items-center">
              <div class="mr-3">
                <div :class="`rounded-circle p-2 bg-light-${contador.color}`">
                  <feather-icon
                    :icon="contador.icon"
                    :class="`text-${contador.color}`"
                    size="20"
                  />
                </div>
              </div>
              <div>
                <h5 class="font-weight-bolder mb-0 text-primary">
                  {{ contador.value }}
                </h5>
                <p class="card-text small text-muted mb-0">
                  {{ contador.title }}
                </p>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <template #overlay>
        <div class="text-center">
          <b-spinner md class="mb-2"/>
          <h6 class="text-bold font-weight-bold">Carregando dados da dashboard...</h6>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BOverlay,
  BSpinner,
} from 'bootstrap-vue'
import { Bar } from 'vue-chartjs'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import useDashboardAdmin from '@/composables/useDashboardAdmin'

const BarChart = {
  extends: Bar,
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.$data._chart.destroy()
        this.renderChart(this.chartData, this.options)
      },
    },
  },
}

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BOverlay,
    BSpinner,
    BarChart,
    FeatherIcon,
  },
  setup() {
    const {
      isLoading,
      resumoGeral,
      estatisticasAdmin,
      contagemUsuarios,
      chartDataDesempenho,
      refetchData,
    } = useDashboardAdmin()

    // Opções do gráfico
    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'top',
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
          },
        }],
      },
    }

    return {
      isLoading,
      resumoGeral,
      estatisticasAdmin,
      contagemUsuarios,
      chartDataDesempenho,
      chartOptions,
      refetchData,
    }
  },
}
</script>

<style scoped>
/* Estilos adicionais se necessário */
.card-text {
  line-height: 1.2;
}
.h-100 {
  height: 100% !important;
}
.mb-3 {
  margin-bottom: 1rem !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
</style>